import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const MediaThumbnail = styled.img`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.small};
    width: 120px;
    height: 68px;
    flex-grow: 0;
    flex-shrink: 0;
  `}
`

export const RelatedMediaWrapper = styled(Flex)`
  cursor: pointer;
`
